import {useEffect, useState} from "react"

import { Popover as PopoverComponent } from 'react-tiny-popover'

type PopoverProps = {
  children: any,
  managedVisibility?: boolean,
  renderContent: Function,
  className?: string,
  onHide?: () => void,
  onShow?: () => void,
  handleMobile?: boolean,
    contained?: boolean,
}

export default function Popover ({
    handleMobile = false,
    children,
    className,
    renderContent,
    onHide,
    onShow,
    managedVisibility,
    contained
} : PopoverProps) {

    const [visible, setVisible] = useState<boolean>(false)

    useEffect(() => {
        if (typeof managedVisibility === "boolean" && managedVisibility !== undefined) {
            setVisible(managedVisibility)
        }
    }, [
        managedVisibility
    ])

  return (
      <PopoverComponent
          isOpen={visible}
          containerStyle={{
              zIndex: '2000'
          }}
          positions={['bottom', 'top', 'left', 'right']}
          content={renderContent()}
          clickOutsideCapture={true}
          onClickOutside={() => {
              setVisible(false)
              if (onHide) onHide()
          }}
      >
          <div onClick={() => {
              setVisible(true)
              if (onShow) onShow()
          }}>
              {children}
          </div>
      </PopoverComponent>
  )

}